export const EffectiveEntryStatus = {
  // AFTER is a client-only status: this is used on any stack entry after current.
  After: 'AFTER',
  // BlockedDownstack is a client-only status: an entry that would be Ready but
  // is stacked above a not-ready/draft/closed entry, so it can't merge yet.
  BlockedDownstack: 'BLOCKED_DOWNSTACK',
  Closed: 'CLOSED',
  Draft: 'DRAFT',
  Loading: 'LOADING',
  // MergeConflicts is a client-only status: it is never returned by the server in the
  // stack_mergeability `effectiveEntryStatus` field. It is computed on the client from the
  // individual entries in the Stack condition of the merge requirements.
  MergeConflicts: 'MERGE_CONFLICTS',
  Merged: 'MERGED',
  Merging: 'MERGING',
  // NeedsRebase is a client-only status: it is never returned by the server in the
  // stack_mergeability `effectiveEntryStatus` field. It is computed on the client from the
  // individual entries in the Stack condition of the merge requirements.
  NeedsRebase: 'NEEDS_REBASE',
  NotReady: 'NOT_READY',
  Queued: 'QUEUED',
  Ready: 'READY',
} as const

export type EffectiveEntryStatus = (typeof EffectiveEntryStatus)[keyof typeof EffectiveEntryStatus]
